var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TheNavigation'),(false)?_c('Header'):_vm._e(),_c('Header2'),_c('div',{staticClass:"container app-container px-5 pb-5 "},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }